export async function refreshAndInitializeLightbox(): Promise<void> {
	await import("../assets/js/fslightbox-pro-3.4.1/fslightbox.js");
	window.refreshFsLightbox?.();
}
